import { connect } from 'react-redux';
import TranslateName from '../../components/Common/Translate';


function mapStateToProps(state) {
    return {
        language: state.i18n.locale,
    }
}
export default connect(mapStateToProps, null)(TranslateName)



// WEBPACK FOOTER //
// ./master/jsx/containers/Translate/translate.jsx